export default __webpack_public_path__ + "static/media/img_2.3324a3f4.png";